import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setApply,
  setEditOrder,
  setFrais,
  setMenu,
  setMode,
  setModeName,
  setModeSelectedId,
  setOpenModal,
  setProduct,
  setRestaurantSelected,
  setRestaurantSlug,
  setTaux,
} from "../../../../shared/slice/restaurant/RestaurantSlice";
import {
  getMenuByStore,
  getMode,
  getModeConsomation,
  getProductByStoreByMode,
  getProductByStoreByModeWithout,
  getStoreById,
  getStoreID,
} from "../../../../shared/slice/restaurant/RestaurantService";
import Menu from "../../../../components/Menu/Menu";
import MyNavBar from "../../../../components/Navbar/MyNavBar";
import StoreNavbar from "../../../../components/StoreNavbar/StoreNavbar";
import { lighten } from "polished";
import ModalModes from "../../../../components/Modals/ModalModes";
import ModalStores from "../../../../components/Modals/ModalStores";
import {
  setModeDelivery,
  setModesModal,
} from "../../../../shared/slice/ModalMode/ModalMode";
import { BaseURI, ImageURI, store } from "../../../../shared";
import { setRootLoading } from "../../../../shared/slice/rootSlice";
import { setOrder } from "../../../../shared/slice/order/OrderSlice";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import { setmodalCheckout } from "../../../../shared/slice/auth/AuthSlice";
import { setOpenCheckOut } from "../../../../shared/slice/ModalStores/ModalStores";
import Logo from "../../../../assets/images/eatorder-logo-white.png";
import {
  MDBCol,
  MDBContainer,
  MDBFooter,
  MDBIcon,
  MDBRow,
} from "mdb-react-ui-kit";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import TermsPopup from "../../../../components/TermsOfService/TermsPopup";
import { useSocket } from "../../../../utils/socketContext";

export default function SelectStore() {
  const modesModal = useSelector((state) => state.modalMode.modesModal);
  const products = useSelector((state) => state.restaurant.product);
  const { id } = useParams();
  const IDSTORE = useParams().id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const restaurantSelected = useSelector(
    (state) => state.restaurant.restaurantSelected
  );
  const modeSelectedId = useSelector(
    (state) => state.restaurant.modeSelectedId
  );
  const orders = useSelector((state) => state.order.order);
  const loggedInUser = useSelector(
    (state) => state.authentification.loggedInUser
  );
  const loggedInGuest = useSelector(
    (state) => state.authentification.loggedInGuest
  );
  const isLoggedIn = useSelector((state) => state.authentification.isLoggedIn);
  const modes = useSelector((state) => state.restaurant.mode);
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasDirectLinkParams =
    searchParams.has("mode") || searchParams.has("table");
  setModesModal(true);
  const { socket} = useSocket();

  useEffect(() => {
    const fetchModeDetails = async () => {
      if (!modeSelectedId) return;

      try {
        const mode = await getMode(modeSelectedId);
        dispatch(setApply({ apply: mode.mode.applicationType }));
        dispatch(setModeName({ modeName: mode.mode.name }));

        if (mode.mode.applyTaux) {
          dispatch(setTaux({ taux: mode.mode.taux }));
        } else {
          dispatch(setFrais({ frais: mode.mode.frais }));
        }
      } catch (error) {
        console.error("Error fetching mode details:", error);
      }
    };

    fetchModeDetails();
  }, [modeSelectedId]);

  useEffect(() => {
    const initializeStore = async () => {
      dispatch(setRootLoading(false));
      dispatch(setmodalCheckout(false));
      dispatch(setOpenCheckOut(false));
      dispatch(setModeDelivery(false));
      dispatch(setOpenModal({ product: undefined, open: false }));
      dispatch(
        setEditOrder({
          open: false,
          objectOptions: [],
          checkedIndices: [],
          checkedOptions: [],
          counter: {},
          orderQuantity: 0,
          note: undefined,
          size: "",
        })
      );

      try {
        const storeId = await getStoreID(id);
        const [storeData, consumptionModes] = await Promise.all([
          getStoreById(storeId),
          getModeConsomation(storeId),
        ]);

        dispatch(setRestaurantSelected({ restaurantSelected: storeData }));
        dispatch(setMode({ mode: consumptionModes.consumationModes }));

        // Set theme colors
        document.documentElement.style.setProperty(
          "--primaryColor",
          storeData.primairecolor
        );
        document.documentElement.style.setProperty(
          "--primaryColorLight",
          lighten("0.3", storeData.primairecolor)
        );
        document.documentElement.style.setProperty(
          "--secondaryColor",
          storeData.secondairecolor
        );
        document.documentElement.style.setProperty(
          "--secondaryColorLight",
          lighten("0.3", storeData.secondairecolor)
        );

        // Fetch menu and preload images
        const menuData = await getMenuByStore(storeId);
        dispatch(setMenu({ menu: menuData }));

        // Preload category images
        menuData?.categorys?.forEach((category) => {
          const img = new Image();
          img.src = `${ImageURI}/combined-uploads/${category.image}`;
        });
      } catch (error) {
        console.error("Store initialization error:", error);
        navigate("/page404");
      }
    };

    initializeStore();
  }, [id]);

useEffect(() => {
  if (!socket || !restaurantSelected?._id) {
    console.log("⛔ Socket or restaurant ID not ready — skipping setup");
    return;
  }

  const FetchUpdatedMenu = async () => {
    try {
      const res2 = await getMenuByStore(restaurantSelected?._id);
      store.dispatch(setMenu({ menu: res2 }));
    } catch (error) {
      console.error("Error fetching updated menu:", error);
    }
  };

  const decryptData = (encryptedData) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, "secret_key");
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedText) throw new Error("Decryption failed");
      return JSON.parse(decryptedText);
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  };

  const encryptData = (data) =>
    CryptoJS.AES.encrypt(JSON.stringify(data), "secret_key").toString();

  const deleteItemCompletely = (productId, orderKey) => {
    const cryptedOrder = localStorage.getItem("OrderStoreWithID" + IDSTORE);
    let allOrders = cryptedOrder ? decryptData(cryptedOrder) : [];

    const updatedOrders = orders
      .map((order) => {
        if (order.orderKey === orderKey) {
          const index = allOrders.findIndex((o) => o.orderKey === order.orderKey);
          localStorage.removeItem(`QuantityInCart_ForStoreWithId${IDSTORE}_ForProductWith${productId}`);
          allOrders.splice(index, 1);
          return null;
        }
        return order;
      })
      .filter(Boolean);

    store.dispatch(setOrder({ order: updatedOrders }));
    const encryptedOrder = encryptData(allOrders);
    localStorage.setItem(`OrderStoreWithID${IDSTORE}`, encryptedOrder);
  };

  const FetchUpdatedProduct = async () => {
    try {
      const res33 = await getProductByStoreByModeWithout(
        restaurantSelected._id,
        modeSelectedId
      );
      const allOrdersWillDelete = [];

      for (let order of orders) {
        const currentProduct = res33.find((p) => p._id === order.product.id);
        const cachedProduct = products.find((p) => p._id === order.product.id);

        if (JSON.stringify(currentProduct) !== JSON.stringify(cachedProduct)) {
          allOrdersWillDelete.push({ orderKey: order.orderKey, product: order.product });
        }
      }

      store.dispatch(setProduct({ product: res33 }));

      const deletedProductNames = [];
      allOrdersWillDelete.forEach(({ product, orderKey }) => {
        deleteItemCompletely(product.id, orderKey);
        deletedProductNames.push(product.name);
      });

      if (deletedProductNames.length > 0) {
        Swal.fire({
          title: "Products Removed",
          html: `<ul>${deletedProductNames.map((name) => `<li>${name}</li>`).join("")}</ul>`,
          icon: "info",
          confirmButtonText: "OK",
          customClass: { popup: "custom-alert-popup" },
        });
      }
    } catch (error) {
      console.error("Error fetching updated product:", error);
    }
  };

  const fetchUpdatedBoth = async () => {
    await FetchUpdatedMenu();
    await FetchUpdatedProduct();
  };

  // Ajout des listeners socket
  socket.on("UpdatedMenu" + restaurantSelected._id, fetchUpdatedBoth);
  socket.on("UpdatedProduct" + restaurantSelected._id, fetchUpdatedBoth);
  socket.on("UpdatedBoth" + restaurantSelected._id, fetchUpdatedBoth);

  // Nettoyage
  return () => {
    socket.off("UpdatedMenu" + restaurantSelected._id, fetchUpdatedBoth);
    socket.off("UpdatedProduct" + restaurantSelected._id, fetchUpdatedBoth);
    socket.off("UpdatedBoth" + restaurantSelected._id, fetchUpdatedBoth);
  };
}, [socket, restaurantSelected?._id, modeSelectedId]);


  useEffect(() => {
    const getmode = async () => {
      if (modeSelectedId) {
        const mode = await getMode(modeSelectedId);
        if (mode.mode.applyTaux) {
          dispatch(setTaux({ taux: mode.mode.taux }));
        } else {
          dispatch(setFrais({ frais: mode.mode.frais }));
        }
        dispatch(setApply({ apply: mode.mode.applicationType }));
        dispatch(setModeName({ modeName: mode.mode.name }));
      }
    };
    getmode();
  }, [modeSelectedId, restaurantSelected?._id]);
  useEffect(() => {
    document.body.style.overflow = modesModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modesModal]);

  const preloadImages = (filteredCategories) => {
    filteredCategories.forEach((category) => {
      const img = new Image();
      img.src = `${ImageURI}/combined-uploads/${category.image}`;
    });
  };

  useEffect(() => {
    const fetchedStoresById = async () => {
      store.dispatch(setRootLoading(false));
      store.dispatch(setmodalCheckout({ modalCheckout: false }));
      store.dispatch(setOpenCheckOut({ setOpenCheckOut: false }));

      //document.documentElement.style.overflow = 'hidden';
      // console.log("--------------------------",ModelGuest)
      // store.dispatch(setToken({}));
      // store.dispatch(setLoggedInGuest({ user: {} }));
      store.dispatch(setModeDelivery({ modeDelivery: false }));
      store.dispatch(
        setOpenModal({
          product: undefined,
          open: false,
        })
      );

      store.dispatch(
        setEditOrder({
          open: false,
          objectOptions: [],
          checkedIndices: [],
          checkedOptions: [],
          counter: {},
          orderQuantity: 0,
          note: undefined,
          size: "",
        })
      );
      store.dispatch(setModesModal({ modesModal: true }));
      const StroreeId = await getStoreID(id);

      getModeConsomation(StroreeId)
        .then((res4) => {
          dispatch(setMode({ mode: res4.consumationModes }));
          // console.log(res4.consumationModes);
        })
        .catch((err) => {
          // console.log("Page not found");
          navigate(`/page404`);
        });

      getStoreById(StroreeId)
        .then(async (res) => {
          dispatch(setRestaurantSelected({ restaurantSelected: res }));
          // dispatch(setModeSelectedId({ modeSelectedId: res.defaultMode }))

          dispatch(setModeSelectedId({ modeSelectedId: modeSelectedId }));
          document.documentElement.style.setProperty(
            "--primaryColor",
            res.primairecolor
          );
          document.documentElement.style.setProperty(
            "--primaryColorLight",
            lighten("0.3", res.primairecolor)
          );

          getMenuByStore(StroreeId)
            .then((res2) => {
              dispatch(setMenu({ menu: res2 }));
              preloadImages(res2?.categorys);
            })
            .catch((err) => {
              console.log("Page not found");
              navigate(`/page404`);
            });

          // const storedOrders = localStorage.getItem('OrderStoreWithID'+id);
          // const orders = JSON.parse(storedOrders); // Convert to JavaScript object

          // if (orders) {
          //     dispatch(setOrder({ order: orders }));
          // }
        })
        .catch((err) => {
          console.log("Page not found");
          navigate(`/page404`);
        });
    };

    fetchedStoresById();
  }, []);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {restaurantSelected && modes ? (
        <div style={{ flex: 1 }}>
          <div
            style={{
              position: "sticky",
              top: "0",
              zIndex: "1005",
              backgroundColor: "white",
            }}
          >
            <MyNavBar />
            {!hasDirectLinkParams && <ModalModes />}
            <StoreNavbar />
            <ModalStores />
          </div>

          {isLoggedIn &&
            ((loggedInUser && !loggedInUser.termsAccepted) ||
              (loggedInGuest && !loggedInGuest.termsAccepted)) && (
              <TermsPopup />
            )}

          <Menu />
        </div>
      ) : (
        <div style={{ flex: 1 }}>
          {modes && !hasDirectLinkParams && <ModalModes />}
        </div>
      )}

      <FooterContainer>
        <MDBFooter
          style={{ fontSize: "1rem" }}
          bgColor="dark"
          className="text-center text-lg-start text-light"
        >
          <FooterSection className="d-flex flex-column flex-lg-row justify-content-between align-items-center p-4 border-bottom border-light">
            <SocialIcons>
              <span>{t("Get connected with us on social networks")}</span>
              <IconsContainer>
                <a
                  href="#"
                  className="me-3 text-reset text-light"
                  aria-label="Facebook"
                >
                  <MDBIcon fab icon="facebook-f" />
                </a>
                <a
                  href="#"
                  className="me-3 text-reset text-light"
                  aria-label="Twitter"
                >
                  <MDBIcon fab icon="twitter" />
                </a>
                <a
                  href="#"
                  className="me-3 text-reset text-light"
                  aria-label="Google"
                >
                  <MDBIcon fab icon="google" />
                </a>
                <a
                  href="#"
                  className="text-reset text-light"
                  aria-label="Instagram"
                >
                  <MDBIcon fab icon="instagram" />
                </a>
              </IconsContainer>
            </SocialIcons>
            <LinkContainer>
              <AnimatedLink href="/privacy-policy">
                {t("Privacy Policy")}
              </AnimatedLink>
              <AnimatedLink href="/terms-of-service">
                {t("Terms of Service")}
              </AnimatedLink>
            </LinkContainer>
          </FooterSection>
          <section className="">
            <MDBContainer className="text-center text-md-start mt-5">
              <MDBRow className="mt-3">
                <MDBCol
                  md="3"
                  lg="4"
                  xl="3"
                  className="mx-auto mb-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <h6 className="text-uppercase fw-bold mb-4">
                    <LogoImageFooter src={Logo} alt="Eatorder Logo" />
                  </h6>
                  <DescriptionText>
                    {t(
                      "Craving something delicious? Order your favorite meals from our platform and enjoy fast, easy, and reliable food delivery. Discover a wide variety of cuisines, exclusive deals, and hassle-free ordering. Satisfaction guaranteed with every bite."
                    )}
                  </DescriptionText>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </section>
        </MDBFooter>
      </FooterContainer>
    </div>
  );
}

// In your ModalModes component
const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  z-index: 1051;
  background: white;
  /* other styles */
`;

const FooterContainer = styled.div`
  position: relative;
  z-index: 1; // Lower than modal but higher than other content
  margin-top: auto; // Pushes footer to bottom
`;

const LogoImageFooter = styled.img`
  height: 18px;
  @media (min-width: 768px) {
    height: 25px;
  }
`;

const AnimatedLink = styled.a`
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease, border-bottom 0.3s ease;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #ddd;
    border-bottom: 1px solid #ddd;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem; /* Smaller font size on smaller screens */
  }
`;

const FooterSection = styled.section`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-bottom: 1rem; /* Add some space below the links on small screens */

  @media (min-width: 768px) {
    /* Keep links in a row on larger screens */
    margin-bottom: 0; /* Remove bottom margin on larger screens */
  }
`;

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: column;
  text-align: center;

  span {
    @media (max-width: 576px) {
      display: none; /* Hide the text on very small screens */
    }
  }
  @media (max-width: 576px) {
    margin-bottom: 2rem !important;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const IconsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const DescriptionText = styled.p`
  font-size: 0.9rem; /* Slightly smaller font size for the description */
  text-align: center; /* Center the description text */
  @media (max-width: 576px) {
    font-size: 0.8rem; /* Even smaller on very small screens */
  }
`;
